import { useRef, useState } from "react";
import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { Loading } from "../../lib/api";
import { PackagePhoto } from "./PackagePhoto";

const compress = async (file) => {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, 1600 / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  return new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.82));
};

export const PhotoCapture = ({ value, onChange }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const { photo_id } = await Loading.uploadPhoto(await compress(file));
      onChange(photo_id);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Nie udało się zapisać zdjęcia");
    } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-1.5" data-testid="photo-capture">
      {value && (
        <div className="relative">
          <PackagePhoto id={value} className="w-11 h-11" testId="photo-capture-preview" />
          <button type="button" data-testid="photo-capture-remove" onClick={() => onChange(null)} aria-label="Usuń zdjęcie" className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-red-600 text-white flex items-center justify-center shadow"><X className="w-3 h-3" /></button>
        </div>
      )}
      <button type="button" data-testid="photo-capture-btn" disabled={busy} onClick={() => input.current?.click()} aria-label={value ? "Zmień zdjęcie" : "Zrób zdjęcie"} title={value ? "Zmień zdjęcie" : "Zrób zdjęcie"} className="w-11 h-11 inline-flex items-center justify-center rounded-xl bg-zinc-900 text-white hover:bg-orange-600 transition-colors disabled:opacity-50">
        {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Camera className="w-5 h-5" />}
      </button>
      <input ref={input} data-testid="photo-capture-input" type="file" accept="image/jpeg,image/png,image/webp" capture="environment" onChange={pick} className="hidden" />
    </div>
  );
};
